<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { useTasksStore } from "@/stores/v2";
import { storeToRefs } from "pinia";

interface Props {
  showModal: boolean;
}

defineProps<Props>();
const emit = defineEmits<{
  close: [];
}>();

const { activeTask } = storeToRefs(useTasksStore());

const handleClose = () => {
  emit('close');
};
</script>

<template>
  <ModalBox v-if="showModal" @close="handleClose">
    <template #header>
      Instructions
    </template>
    <template #main>
      <div class="space-y-4">
        <p class="text-gray-700">
          {{ activeTask?.description || 'No instructions available for this task.' }}
        </p>
      </div>
    </template>
    <template #footer>
      <button 
        @click="handleClose" 
        type="button"
        class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
      >
        Close
      </button>
    </template>
  </ModalBox>
</template> 